// notificationSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import {
  NotificationState
} from './notificationTypes';
import {
  createNotification,
  fetchAllNotifications,
  fetchNotificationById,
  deactivateNotification
} from './notificationActions';

const initialState: NotificationState = {
  notifications: [],
  selectedNotification: undefined,
  loading: false,
  error: undefined,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createNotification.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications.push(action.payload);
      })
      .addCase(createNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllNotifications.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAllNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload;
      })
      .addCase(fetchAllNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch by ID
      .addCase(fetchNotificationById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchNotificationById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedNotification = action.payload;
      })
      .addCase(fetchNotificationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Deactivate
      .addCase(deactivateNotification.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deactivateNotification.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.notifications.findIndex(n => n.id === action.payload.id);
        if (index !== -1) {
          state.notifications[index].isActive = false;
        }
      })
      .addCase(deactivateNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

export default notificationSlice.reducer;
